<template>
  <div class="bg-white">
    <Details />

    <GalleryDetails />
    <div class="bge3ceff-opa rounded-t-5555 mt-12 relative zindex1">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import Details from "./components/Details.vue";
import DownloadApp from "../future-trends/components/DownloadApp.vue";
import GalleryDetails from "./components/GalleryDetails.vue";
import Footer from "../Footer.vue";
import { mapState } from "vuex";
export default {
  components: {
    Details,
    GalleryDetails,
    DownloadApp,
    Footer,
  },
  data() {
    return {
      meta_title: "",
      meta_description: "",
      meta_canonical: "",
      meta_keyword: "",
    };
  },
  computed: {
    ...mapState("ffc", ["selected_event", "selected_event_type"]),
  },
  metaInfo() {
    return {
      title: this.selected_event.metaTitle,
      // title: "Our Event",
      meta: [
        {
          name: "keyword",
          content: this.selected_event.metaKeyword,
        },
        {
          name: "description",
          content: this.selected_event.metaDesc,
        },
        {
          rel: "canonical",
          href: this.selected_event.metaCanonicalTag,
        },
      ],
    };
  },
  watch: {
    selected_event(value) {
      if (value) {
        this.meta_title = this.selected_event.metaTitle;
        this.meta_description = this.selected_event.metaDesc;
        this.meta_canonical = this.selected_event.metaCanonicalTag;
        this.meta_keyword = this.selected_event.metaKeyword;
      }
    },
  },
};
</script>
